import gql from "graphql-tag"

import wellnessMediaAuthor from "./WellnessMediaAuthor"
import wellnessMediaProvider from "./WellnessMediaProvider"
import wellnessMediaCategory from "./WellnessMediaCategory"

const fragment = gql`
  fragment wellnessMedia on WellnessMedia {
    uuid
    title
    tags
    categoryId
    category {
      ...wellnessMediaCategory
    }
    type
    thumbnail
    heroImage
    duration
    liveVideoStartTime
    liveVideoEndTime
    src
    providerId
    provider {
      ...wellnessMediaProvider
    }
    image
    description
    courseMediaCount
    authorId
    author {
      ...wellnessMediaAuthor
    }
  }
  ${wellnessMediaAuthor}
  ${wellnessMediaProvider}
  ${wellnessMediaCategory}
`

export const toString = fragment.loc.source.body

export default fragment
